import React from 'react';
import i18n from '@i18n';
import { useXFBML } from '@/common/deferSdk/FbSdk';

function FacebookShareModule() {
    const parseContainer = useXFBML();

    return (
        <div className="markdown-facebook" ref={parseContainer} data-atid="markdown-facebook-share">
            <div
                className="fb-share-button"
                data-href={window.location.href}
                data-layout="button_count"
                data-size="large"
            >
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
                    className="fb-xfbml-parse-ignore"
                >
                    {i18n('markdown.fb.share.btn')}
                </a>
            </div>
        </div>
    );
}

export default FacebookShareModule;
